// extracted by mini-css-extract-plugin
export default {"layout":"_33a3bad979 _6733652d1f _44d6d1af26","h_slide":"_4a3b0b0f7f","category":"d43b434f91 f3c776eea2 cd1f02e5b4"};